import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import { Button, Tooltip } from "antd";
import { observer } from "mobx-react-lite";
import React, { useState } from "react";

interface ShiftTooltipProps {
    orderId: number;
    children: JSX.Element;
}

const ShiftTooltip: React.FC<ShiftTooltipProps> = function (props) {
    const { orderId, children } = props;
    const orderManagementStore = useOrderManagementStore();
    const [innerVisible, updateInnerVisible] = useState(false);

    if (orderManagementStore.table.disabledShowShiftTip) return children;

    const targetVisible = orderManagementStore.table.hintShiftTipOrderId === orderId;

    const mergedVisible = targetVisible || innerVisible;

    return (
        <Tooltip
            open={mergedVisible}
            title={
                <div
                    className="small"
                    onMouseEnter={() => {
                        updateInnerVisible(true);
                    }}
                    onMouseLeave={() => {
                        updateInnerVisible(false);
                    }}
                >
                    <p>连续选择多个订单操作方法：</p>
                    <p>
                        <span>按住 Shift 键，选中第一个和最后一个订单</span>
                        <Button
                            style={{ height: "auto" }}
                            type="link"
                            className="ml5 small"
                            onClick={orderManagementStore.table.handleNeverShopShiftTip}
                        >
                            不再提醒
                        </Button>
                    </p>
                </div>
            }
            styles={{ body: {
                width: 290,
            } }}
        >
            {children}
        </Tooltip>
    );
};

export default observer(ShiftTooltip);
